import { DeleteAdjustmentStatment, DeleteAdjustmentStatmentVariables } from "_graphql/mutation/__generated__/DeleteAdjustmentStatment";
import { RemoveReBokerFromTreatyList, RemoveReBokerFromTreatyListVariables } from "_graphql/mutation/__generated__/RemoveReBokerFromTreatyList";
import { deleteAdjustmentStatment, removetreatyBroker } from "_graphql/visal/mutations/treaty";
import { useMatch, useSearch } from "react-location";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";

export default function RemoveAdjustmentStatementContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const { params } = useMatch<LocationGenerics>();
    const [remove, { loading }] = useMutation<DeleteAdjustmentStatment, DeleteAdjustmentStatmentVariables>(deleteAdjustmentStatment, {
        refetchQueries: ["Treaty"]
    });


    const handleSubmit = async () => {
        await remove({
            variables: {
                treaty_id: params?.treaty || "",
                treaty_np_detail_id: searchParams?.id || "",
            },
        }).then(({ data }) => {
            if (data?.deleteAdjustmentStatment) {
                toast.success("Adjustment Statement removed successfully");
                refetch?.();
                setOpen?.(false);
            } else {
                toast.error("Failed to remove adjustment statement");
            }
        });
    }

    return (
        <PopUp
            open={open}
            setOpen={setOpen}
            title="Remove Adjustment Statement"
            cancelText="No, Don't Remove"
            description="Are you sure you want to remove this adjustment statement? This action cannot be undone."
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={handleSubmit}
                    >
                        {loading ? "Removing ..." : "Remove Adjustment Statement"}
                    </button>
                </>
            )}
        />
    );
}
